import { getUserSession } from "../../core/util/core/Session"

export const chooseProfileFilter = () => {
    const session = getUserSession()

    const { loggedUserInfo } = session

    return loggedUserInfo
}